import { Workbook } from 'exceljs'
import { CitizenFullInfo, cardStatusName, citizenGetAddress, citizenGetFullname } from '@prodcard/core'
import { head, last } from 'lodash'

export function createSheetCitizens(workbook: Workbook, sheetName: string, citizens: CitizenFullInfo[]) {
  const worksheet = workbook.addWorksheet(sheetName)
  worksheet.columns = [
    { header: 'ФИО', width: 40 },
    { header: 'Дата рождения', width: 15 },
    { header: 'Тип документа', width: 25 },
    { header: 'Данные документа', width: 25 },
    { header: 'Адрес регистрации', width: 25 },
    { header: 'MO', width: 25 },
    { header: 'Cтатус карты', width: 25 },
  ]

  citizens.forEach(({ citizen, document, cardStatus, municipalEntity }) => {
    worksheet.addRow([
      citizenGetFullname(citizen),
      new Date(citizen.birthdate).toLocaleDateString('ru-Ru'),
      document.type,
      document.info,
      citizenGetAddress(citizen),
      municipalEntity,
      cardStatusName(cardStatus),
    ])
  })

  const countRow = worksheet.addRow([`Итого: ${citizens.length}`, ...new Array(worksheet.columns.length - 1)])
  const letters = worksheet.columns.map(c => c.letter)
  worksheet.mergeCells(`${head(letters)}${countRow.number}:${last(letters)}${countRow.number}`)
}
